import type { ModelData } from '@/shared/stores/model-utils'

export const model13InitialModel: ModelData = {
    name: 'Template 13 - Single Door With Solid Frames',
    modelId: 'model13',
    type: 'DOOR',
    description: '13-variant door with solid frames and single door opening',
    width: 2000,
    height: 2200,
    photoId: null,
    attachments: [],
    parameters: [
      // Frame profiles
      {
        positionId: 'top_frame_profile',
        type: 'PROFILE',
        width: 2000,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 0, y: 0, z: 0 },
      },
      {
        positionId: 'bottom_left_frame_profile',
        type: 'PROFILE',
        width: 550,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 0, y: 2140, z: 0 },
      },
      {
        positionId: 'door_1_bottom_frame_profile',
        type: 'PROFILE',
        width: 900,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 550, y: 2140, z: 0 },
      },
      {
        positionId: 'door_1_top_frame_profile',
        type: 'PROFILE',
        width: 900,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 550, y: 320, z: 0 },
      },
      {
        positionId: 'door_1_left_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 1880,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 550, y: 320, z: 0 },
      },
      {
        positionId: 'door_1_right_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 1880,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 1390, y: 320, z: 0 },
        hardware: {
          hinges: [
            {
              positionId: 'door_1_right_top_hinge_1',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 60, y: 60, z: 10 },
            },
            {
              positionId: 'door_1_right_top_hinge_2',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 60, y: 310, z: 10 },
            },
            {
              positionId: 'door_1_right_top_hinge_3',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 60, y: 560, z: 10 },
            },
            {
              positionId: 'door_1_right_bottom_hinge_1',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 60, y: 1350, z: 10 },
            },
            {
              positionId: 'door_1_right_bottom_hinge_2',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 60, y: 1550, z: 10 },
            },
          ],
        },
      },
      {
        positionId: 'bottom_right_frame_profile',
        type: 'PROFILE',
        width: 550,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 1450, y: 2140, z: 0 },
      },
      {
        positionId: 'left_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 2200,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 0, y: 0, z: 0 },
      },
      {
        positionId: 'left_vertical_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 2140,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 490, y: 60, z: 0 },
      },
      {
        positionId: 'right_vertical_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 2140,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 1450, y: 60, z: 0 },
      },
      {
        positionId: 'middle_horizontal_frame_profile',
        type: 'PROFILE',
        width: 900,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 550, y: 260, z: 0 },
      },
      {
        positionId: 'right_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 2200,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 1940, y: 0, z: 0 },
      },
      // Glass panels - Template13 layout
      {
        positionId: 'left_glass_panel',
        type: 'GLASS',
        width: 430,
        height: 2080,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        material: 'clear_glass',
        materialId: null,
        isDouble: false,
        position: { x: 60, y: 60, z: 0 },
      },
      {
        positionId: 'door_top_glass_panel',
        type: 'GLASS',
        width: 900,
        height: 200,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        material: 'clear_glass',
        materialId: null,
        isDouble: false,
        position: { x: 550, y: 60, z: 0 },
      },
      {
        positionId: 'door_glass_panel',
        type: 'GLASS',
        width: 780,
        height: 1760,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        material: 'clear_glass',
        materialId: null,
        isDouble: false,
        position: { x: 610, y: 380, z: 0 },
        hardware: {
          handles: [
            {
              positionId: 'door_horizontal_handle',
              type: 'HORIZONTAL_HANDLE',
              width: 120,
              height: 200,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: -70, y: 900, z: 10 },
            },
          ],
        },
      },
      {
        positionId: 'right_glass_panel',
        type: 'GLASS',
        width: 430,
        height: 2080,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        material: 'clear_glass',
        materialId: null,
        isDouble: false,
        position: { x: 1510, y: 60, z: 0 },
      },
    ],
    doorConfiguration: {
      type: 'single_door',
      totalDoorWidth: 900,
      individualDoorWidth: [900],
      totalHandles: 1,
      openingDirection: 'right_opening',
      hingePosition: 'right_side',
    },
  }
